<template>
    <div class="row align-items-center c-contestant-header">
        <div class="col-12 col-md-6">
            <h3 class="c-contestant-header__title">
                {{ hasContendersPresent ? contestantGridHeading : contestNotactiveText }}
            </h3>
        </div>
        <div class="col-12 offset-md-3 col-md-3"
            v-if="hasContendersPresent && !hideSearchbox">
            <div class="position-relative">
                <div>
                    <input type="text" class="form-control c-contestant-header__autocomplete"
                        :placeholder="searchboxText" v-model="search"
                    >
                    <div class="close-icon d-block position-absolute" :tabindex="search ? '0' : '-1'"
                        role="button"
                        aria-label="Reset the search results"
                        @keydown.enter="selectResult('')" @click="selectResult('')">
                        <i class="icon-times"></i>
                    </div>
                    <p class="sr-only" role="alert" v-if="search || hasShowUpdatedSearchedResult">
                        {{ updatedSearchedResult }}
                    </p>
                </div>
            </div>
        </div>
        <div class="col-12" v-if="hasContendersPresent && !hideGreybar">
            <hr class="divider mb-0" />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            search: '',
            updatedSearchedResult: '',
            hasShowUpdatedSearchedResult: false,
        };
    },
    props: {
        contestantGridHeading: String,
        contestNotactiveText: String,
        contendersList: Array,
        updatedSearchedContenderList: Array,
        hideSearchbox: Boolean,
        searchboxText: String,
        hideGreybar: Boolean,
    },
    computed: {
        hasContendersPresent() {
            return this.contendersList && this.contendersList.length;
        }
    },
    watch: {
        search(val) {
            this.$emit('setSearchResult', val);
        },
        updatedSearchedContenderList(val) {
            this.updatedSearchedResult = `${val.length} results found`;
            setTimeout(() => {
                this.updatedSearchedResult = '';
                this.hasShowUpdatedSearchedResult = false;
            }, 500);
        },
    },
    methods: {
        selectResult(result) {
            this.search = result;
            this.hasShowUpdatedSearchedResult = true;
            this.$emit('setSearchResult', this.search);
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/app/components/contestant-grid-header.vue